// angular
import {
  Component,
  effect,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// components
import { TenderCountdownTimerComponent } from '@tenders/shared/components/tender-countdown-timer/tender-countdown-timer.component';
import { TenderDeliveryTabComponent } from '../tender-delivery-tab/tender-delivery-tab.component';
import { TenderSubmitQuoteTabComponent } from '../tender-submit-quote-tab/tender-submit-quote-tab.component';
// services
import { UserService } from '@app/shared/services/user.service';
// types
import { ITender } from '@tenders/shared/interfaces/tender.interface';
import { ISectionTab } from '@app/core/shared/interfaces/section-tab.interface';

export type TenderProposalTab = 'submit-quote' | 'delivery-address';

@Component({
  selector: 'pwj-tender-proposal-panel',
  standalone: true,
  imports: [
    TranslateModule,
    TenderCountdownTimerComponent,
    TenderDeliveryTabComponent,
    TenderSubmitQuoteTabComponent,
  ],
  templateUrl: './tender-proposal-panel.component.html',
  styleUrl: './tender-proposal-panel.component.scss',
})
export class TenderProposalPanelComponent {
  tender = input.required<ITender>();
  isActive = input<boolean>(false);

  submitQuote = output<void>();

  activeTab = signal<TenderProposalTab>('submit-quote');
  isUserLoggedIn = false;
  tabs: ISectionTab[] = [
    { tabTitle: 'submit-quote' },
    { tabTitle: 'delivery-address' },
  ];

  private readonly _userService = inject(UserService);

  constructor() {
    effect(() => {
      this.isUserLoggedIn =
        (this._userService.userSignal()?.roles?.length || 0) > 0;
    });
  }

  onSelectTab(tabTitle: string): void {
    this.activeTab.set(tabTitle as TenderProposalTab);
  }

  getTabLabel(tabTitle: string): string {
    const labels: Record<string, string> = {
      'submit-quote': 'tenders.submitQuote',
      'delivery-address': 'tenders.deliveryAddress',
    };

    return labels[tabTitle] || tabTitle;
  }
}
